/* eslint-disable react-hooks/exhaustive-deps */
import axios from '../config/axios';
import { useEffect, useState } from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
// import useSocket from '../hook/useSocket';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

function Humadity() {
  // const { label, dataset } = useSocket();
  const [dataLabel, setDataLabel] = useState([]);
  const [dataDataset, setDataDataset] = useState([]);

  useEffect(() => {
    fetchDataAwlr();
  }, []);

  // useEffect(() => {
  //   console.log('data label', dataLabel);
  //   setDataLabel([...dataLabel, ...label]);
  // }, [label]);

  // useEffect(() => {
  //   console.log('dataset', dataset);
  //   if (dataset.length > 0) {
  //     let dataSetJson = dataset[0];
  //     setDataDataset([...dataDataset, dataSetJson[1].data]);
  //   }
  // }, [dataset]);

  const fetchDataAwlr = async () => {
    try {
      const res = await axios.get('/api/telemetri/awlr');
      console.log('res', res.data.data);
      let awlr = res.data.data;
      let dlabel = [];
      let dset = [];
      for (let index = awlr.length - 1; index >= 0; index--) {
        dlabel = [...dlabel, awlr[index].waktu];

        // setDataLabel([...dataLabel, awlr[index].waktu]);
        let set = JSON.parse(awlr[index].data);
        console.log('set', set);
        dset = [...dset, set[1].data];
        // setDataDataset([...dataDataset, dset[0].data]);
      }
      console.log(dlabel, dset);
      setDataLabel(dlabel);
      setDataDataset(dset);
    } catch (error) {
      console.error(error.response);
    }
  };

  return (
    <div className="w-full">
      <div className="border-b bg-white p-4 font-bold uppercase">Humadity</div>
      <div className="mx-auto h-full w-full flex-1 p-4">
        <div className="rounded-md border bg-white p-4">
          <Line
            data={{
              labels: [...dataLabel],
              datasets: [
                {
                  id: 1,
                  label: 'Humadity',
                  data: [...dataDataset],
                  borderColor: 'rgb(53, 162, 235)',
                  backgroundColor: 'rgba(53, 162, 235, 0.5)',
                },
              ],
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default Humadity;
